var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5645 11.2545H11.7705L11.4945 10.9805C12.4695 9.84348 13.0625 8.36948 13.0625 6.75448C13.0625 3.16448 10.1525 0.254484 6.5625 0.254484C2.9725 0.254484 0.0625 3.16448 0.0625 6.75448C0.0625 10.3445 2.9725 13.2545 6.5625 13.2545C8.1775 13.2545 9.6505 12.6625 10.7875 11.6885L11.0635 11.9625V12.7545L16.0615 17.7455L17.5525 16.2545L12.5645 11.2545ZM6.5625 11.2545C4.0765 11.2545 2.0625 9.24048 2.0625 6.75448C2.0625 4.26948 4.0765 2.25448 6.5625 2.25448C9.0475 2.25448 11.0625 4.26948 11.0625 6.75448C11.0625 9.24048 9.0475 11.2545 6.5625 11.2545Z",
    fill: "#979DA5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1fa7c6acafbfc38714cb29ac0c80f257.svg";
export { ForwardRef as ReactComponent };